import React from 'react';
import { Box, Typography, Link, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Link as RouterLink } from 'react-router-dom';
import { useFooter } from '../contexts/FooterContext';
// Brand tokens — keeps the compact app footer consistent with the redesigned
// evergreen header (see docs/landing-page-redesign/IMPLEMENTATION.md).
import { LANDING_FONT, LC, r } from './landing/landingTokens';

const Footer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { showFooter } = useFooter();

  return (
    <Box
      component="footer"
      sx={{
        py: 0.75,
        px: 0,
        mt: '0',
        backgroundColor: LC.evergreen,
        borderTop: `${r(1)} solid rgba(255, 255, 255, 0.1)`,
        color: LC.navLink,
        textAlign: 'center',
        height: isMobile ? '2.5rem' : '2rem',
        display: showFooter ? 'flex' : 'none',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        mb: isMobile ? '3.5rem' : 0,
        position: 'relative',
        zIndex: 10
      }}
    >
      <Typography
        variant="caption"
        sx={{
          display: { xs: 'block', sm: 'inline' },
          fontFamily: LANDING_FONT,
          fontSize: '0.7rem',
          lineHeight: 1.2,
          '& a:hover': { color: 'primary.contrastText' },
        }}
      >
        <Link component={RouterLink} to="/contact-us" color="inherit" underline="hover" sx={{ mx: '0.25rem' }}>
          Contact Us
        </Link>
        {' | '}
        <Link component={RouterLink} to="/about-us" color="inherit" underline="hover" sx={{ mx: '0.25rem' }}>
          Our Story
        </Link>
        {' | '}
        <Link component={RouterLink} to="/privacy-policy" color="inherit" underline="hover" sx={{ mx: '0.25rem' }}>
          Privacy Policy
        </Link>
        {' | '}
        <Link component={RouterLink} to="/terms-of-use" color="inherit" underline="hover" sx={{ mx: '0.25rem' }}>
          Terms of Use
        </Link>
        {' | '}
        {' © '}
        {new Date().getFullYear()} myStack
      </Typography>
    </Box>
  );
};

export default Footer;